import Typography from '@mui/material/Typography';
import React, { useMemo } from 'react';

import { useAppSelector } from '@/hooks/redux';
import { useTranslate } from '@/hooks/useTranslate';

import { selectConfigsState } from '@/redux/configs';

import { AccountTypeDetails } from '@/types/api/account';

import { renderHTMLText } from '@/utils/string';

import { getAccountHighlightFigure } from '../utils/account';

type FigureForAccountProps = {
  account: AccountTypeDetails;
};

const FigureForAccountComponent: React.FC<FigureForAccountProps> = ({
  account,
}) => {
  const { translateIfExists, language } = useTranslate();
  const { currencyPlacement } = useAppSelector(selectConfigsState);

  const { figure, figureSubText, figureDescription } = useMemo(
    () => getAccountHighlightFigure(account, language),
    [account, language],
  );

  const placement = currencyPlacement[language] ?? 'after';

  if (!figure) {
    return null;
  }

  return (
    <Typography variant="h1" mb={2}>
      {placement === 'after' ? (
        <>
          {figure}
          {figureSubText && (
            <Typography variant="h4" component="span">
              {figureSubText}
            </Typography>
          )}
        </>
      ) : (
        <>{`${figureSubText ?? ''}${figure}`}</>
      )}

      {figureDescription && (
        <>
          <br />
          <Typography variant="body2" mt={-0.75}>
            {renderHTMLText(
              translateIfExists(figureDescription || '') ||
                figureDescription ||
                '',
            )}
          </Typography>
        </>
      )}
    </Typography>
  );
};

export const FigureForAccount = React.memo(FigureForAccountComponent);
